// One calendar policy for API, scheduler and client. Week keys are UTC Mondays.
export const PROTECTED_WEEK_KEYS = Object.freeze(["2026-10-05", "2026-10-12"]);
export function currentMondayUtc(now = new Date()) {
  const monday = new Date(now);
  monday.setUTCDate(monday.getUTCDate() - (monday.getUTCDay() + 6) % 7);
  return monday.toISOString().slice(0, 10);
}
export function weeklyCalendarState(week, storedFrozen = false, current = currentMondayUtc()) {
  const period = week === current ? "current" : week < current ? "past" : "future";
  return { period, currentWeek: current, frozen: period === "past" && storedFrozen,
    writable: period === "current", protectedWeek: PROTECTED_WEEK_KEYS.includes(week) };
}
